import { render, staticRenderFns } from "./changeRFCCloseNum.vue?vue&type=template&id=80f1828e&scoped=true&"
import script from "./changeRFCCloseNum.vue?vue&type=script&lang=js&"
export * from "./changeRFCCloseNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f1828e",
  null
  
)

export default component.exports